export enum SupporterErrorTypeEnum {
  SupporterInternalError = 'SUPPORTER_INTERNAL_ERROR',
  SupporterNotFound = 'SUPPORTER_NOT_FOUND',
  SupporterDuplication = 'SUPPORTER_DUPLICATION',
  PaymentMethodsEmpty = 'PAYMENT_METHODS_EMPTY',
  PaymentMethodNotFound = 'PAYMENT_METHOD_NOT_FOUND',
  PaymentMethodHasCommitments = 'PAYMENT_METHOD_HAS_COMMITMENTS',
  PaymentMethodDelete = 'PAYMENT_METHOD_DELETE',
  PaymentMethodCreate = 'PAYMENT_METHOD_CREATE',
  PaymentMethodAlreadyExists = 'PAYMENT_METHOD_ALREADY_EXISTS',
  PaymentMethodUpdate = 'PAYMENT_METHOD_UPDATE',
  PaymentMethodTokenUpdateNotAllowed = 'PAYMENT_METHOD_TOKEN_UPDATE_NOT_ALLOWED',
  PaymentMethodAssignToCommitment = 'PAYMENT_METHOD_ASSIGN_TO_COMMITMENT',
  AddressMissingRequiredField = 'ADDRESS_MISSING_REQUIRED_FIELD',
}
